// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XSg8","badges":"styles_badges__VV65I"};